import { isAuthError, loadConfig } from '@api/api';
import axios, { AxiosResponse } from 'axios';

export interface iISR {
  series_id: string;
  json: object;
}
export interface iISR_input {
  branchid: number;
  proximal_idx: number;
  distal_idx: number;
}

const getISRApi = async (series_id: string) => {
  const BASE_URL = await loadConfig();
  return `${BASE_URL}/api/v1/series/restenosis/${series_id}`;
};

async function ToFormData(info: iISR) {
  const formData = new FormData();
  const json_input = JSON.stringify(info.json);

  const blob = new Blob([json_input], { type: 'application/json' });
  formData.append('file', blob, 'isr.json');
  return formData;
}

export async function send_isr_info(accessToken: string, info: iISR) {
  const url = await getISRApi(info.series_id);

  const send_info = await ToFormData(info);
  const res: AxiosResponse = await axios({
    method: 'post',
    url: url,
    headers: {
      Accept: '*/*',
      Authorization: `Bearer ${accessToken}`,
    },
    data: send_info,
  })
    .then((res) => {
      console.log(res);
      return res;
    })
    .catch((err) => {
      console.log(err);
      return err;
    });

  if (res.status == 201) {
    const isr_result = res.data['data']['ISR']['result'];
    return [true, isr_result];
  }
  return [false, false];
}
async function make_dummy_json(info: iISR_input) {
  return {
    ISR: info,
  };
}
export async function example_send_isr_info(
  accessToken: string,
  series_id: string,
  info: iISR_input,
) {
  const json_info = await make_dummy_json(info);
  const [operation_result, isr_result] = await send_isr_info(accessToken, {
    series_id: series_id,
    json: json_info,
  });

  console.log('run status: ', operation_result);
  console.log('isr result: ', isr_result);
}

export async function isr_function(
  accessToken: string,
  series_id: string,
  branchid: number,
  proximal_idx: number,
  distal_idx: number,
) {
  const info: iISR_input = {
    branchid,
    proximal_idx,
    distal_idx,
  };
  const json_info = await make_dummy_json(info);
  const [operation_result, isr_result] = await send_isr_info(accessToken, {
    series_id,
    json: json_info,
  });

  return { operation_result, isr_result };
}
